// globals COURSERA_APP_VERSION, COURSERA_APP_VERSION_TIMESTAMP

/* eslint-disable */

/**
 * NOTE requiring this has side-effects, trigged on DOM load
 */
import config from 'js/app/config';
import errorTracker from 'js/app/errorTracker';
import logger from 'js/app/loggerSingleton';
import _400 from 'js/lib/400';
import MultiTracker from 'js/lib/multitracker';

var multitracker = MultiTracker({ logger }); // eslint-disable-line new-cap

if (typeof window !== 'undefined') {
  var eventBeacon = window.location.protocol + '//' + window.location.host;
  var inProduction = /production/.test(config.environment);

  errorTracker(
    function (error) {
      multitracker.pushV2(['page.error.javascript', error]);
    },
    {
      logger: logger,
      version: COURSERA_APP_VERSION,
      versionTimestamp: COURSERA_APP_VERSION_TIMESTAMP,
      scriptFilter: new RegExp('^' + config.url.app_chunks),
    }
  );

  multitracker.register('400', _400);
  multitracker.register('ga', (window._gaq = window._gaq || []), 'google');

  multitracker
    .get('400')
    .queue.push(
      [
        'batch',
        ['constant', 'debug', !inProduction],
        ['constant', 'beacon', eventBeacon + '/api/rest/v1/eventing/info'],
        ['constant', 'beaconBatch', eventBeacon + '/api/rest/v1/eventing/infobatch'],
        ['app', 'phoenix'],
        ['clientVersion', COURSERA_APP_VERSION],
      ].concat(window._400)
    );
}

export default multitracker;
